import {
  // getOepVerificationToken,
  livePolyvDetail,
  liveSignup,
  getWxBindStatus,
  getWxPushSwitch,
  setWxPushSwitch
} from "@/api/uPlusApi/live.js";
// import { OpenOepUrl } from "@/utils/live.js";
const liveStatusMap = {
  living: "进行中",
  notyet: "预告",
  ended: "回顾"
};
export default {
  methods: {
    getLiveGuest(liveData) {
      return `${liveData.guest}${
        liveData.guest_desc ? " | " : ""
      }${liveData.guest_desc || ""}`;
    },
    // 看直播
    goLive(liveData, curLiveCategory, openType, isInDetailPage) {
      const stateText =
        liveData.live_status == "ended" && !liveData.course_id
          ? "回顾生成中"
          : liveStatusMap[liveData.live_status] || liveData.live_status;
      this.gioTrackEvent("LB_clickLiveBroadcast", {
        appId_var: 10020,
        liveBroadcastClassificationId_var: curLiveCategory
          ? curLiveCategory.category_id
          : "",
        liveBroadcastClassificationName_var: curLiveCategory
          ? curLiveCategory.category_name
          : "",
        // LbCategory2_id: curLiveCategory ? curLiveCategory.category2_id : "",
        // LbSecondCategoryName_var: curLiveCategory
        //   ? curLiveCategory.category2_name
        //   : "",
        liveBroadcastId_var: liveData.id,
        liveBroadcastName_var: liveData.title,
        liveState_var: stateText
      });
      const { live_status, course_id, replay_mode } = liveData;
      if (live_status == "ended") {
        this.gioTrackEvent("LB_clickLiveBroadcastReview", {
          appId_var: 10020,
          liveBroadcastClassificationId_var: curLiveCategory
            ? curLiveCategory.category_id
            : "",
          liveBroadcastClassificationName_var: curLiveCategory
            ? curLiveCategory.category_name
            : "",
          // LbCategory2_id: curLiveCategory ? curLiveCategory.category2_id : "",
          // LbSecondCategoryName_var: curLiveCategory
          //   ? curLiveCategory.category2_name
          //   : "",
          liveBroadcastId_var: liveData.id,
          liveBroadcastName_var: liveData.title,
          liveState_var: stateText
        });
        if (!course_id) {
          this.$hMessage.info("回放正在生成中，请耐心等待");
          // 弹窗报错
          return;
        }
        // 保利威回放
        if (String(replay_mode) === "1") {
          // 如果是在直播详情页面点击，那么跳转到播放页面
          if (isInDetailPage === true) {
            this.$router.push({
              path: "/uplusLivePlay",
              query: {
                liveId: liveData.id
              }
            });
            return;
          } else {
            // 否则跳转到直播详情页面
            window.open(
              `/openplat-front/uplusLiveDetail?liveId=${liveData.id}`
            );
          }
        } else {
          // 跳转到课堂
          this.goCourse(liveData, openType);
        }
      } else {
        // 如果是在直播详情页面点击调用，那么直接跳转到直播播放页面
        if (isInDetailPage === true) {
          // 获取直播详情
          this.$router.push({
            path: "/uplusLivePlay",
            query: {
              liveId: liveData.id
            }
          });
          return;
        }
        // 否则跳转到直播详情页面
        window.open(`/openplat-front/uplusLiveDetail?liveId=${liveData.id}`);
      }
    },
    // 预约
    handleSignUp(liveData, curLiveCategory) {

      // 已预约的不允许重复预约
      if (liveData.btn_flag === "signed") {
        return;
      }
      
      this.gioTrackEvent("LB_clickLiveBroadcastRegistration", {
        appId_var: 10020,
        liveBroadcastClassificationId_var: curLiveCategory
          ? curLiveCategory.category_id
          : "",
        liveBroadcastClassificationName_var: curLiveCategory
          ? curLiveCategory.category_name
          : "",
        // LbCategory2_id: curLiveCategory ? curLiveCategory.category2_id : "",
        // LbSecondCategoryName_var: curLiveCategory
        //   ? curLiveCategory.category2_name
        //   : "",
        liveBroadcastId_var: liveData.id,
        liveBroadcastName_var: liveData.title
      });
      liveSignup({ id: liveData.id, entry: "PC" }).then(res => {
        if (String(res.error_no) === "0") {
          this.$set(liveData, "sign_flag", 1);
          this.$set(liveData, "btn_flag", "signed");
          //不再提醒
            if(this.nomoreprompt){
              this.$hMessage.success("预约成功");
            }else{
              this.checkWxBindStatus()//判断是否开启服务
            }
          } else {
            this.$hMessage.error("预约失败");
          }
        });
    },
    checkWxBindStatus(){
      getWxPushSwitch({
        uapp_id: 'public'
      }).then((res) => {
        if (String(res.error_no) === '0') {
          if(res.result.switch_status=='0'){
            this.showSubscribeModal = true
          }else{
            this.$hMessage.success("预约成功");
          }
        } else {
          this.$hMessage.success("预约成功");
        }
      })
  },
    // 跳转到课程
    goCourse(data, openType) {
      this.gioTrackEvent("UL_clickCourseDeteil", {
        appId_var: 10021, // 应用id
        // routeName_var: '课程详情', // 路由名称
        courseId_var: data.course_id, // 课程id
        courseName_var: data.title, // 课程名称
        clickArea_var: data.gioAreaName || "直播列表"
      });
      if (!data.course_id) return;
      let openCourseUrl = "";
      if (data.course_id.indexOf("/") !== -1) {
        openCourseUrl = data.course_id;
      } else {
        // 是否使用老的课堂跳转方式
        // 在线课堂改造需求在9.30号上线，为了防止在这之前有其他需求将这里的新跳转地址发布到线上造成bug，所以这里进行控制，默认使用新的跳转地址，如果有问题的话，那么就在https://www.hs.net/r/cms/www/competitionPc2022/staticRecource.js文件中配置courseUseOldJumpUrl为true就能恢复老地址的使用，9.30之后可随时将老的跳转地址处理逻辑删除
        if (window.competitionResource.courseUseOldJumpUrl) {
          const courseUrl = `${window.LOCAL_CONFIG.onlineClassUrl}/oep/userland/course/online/${data.course_id}?jia=2&courseToken=${data.course_token}`;
          openCourseUrl = `/online-console/oeplogin?service=${encodeURIComponent(
            courseUrl
          )}`;
        } else {
          openCourseUrl = `/openplat-front/courseDetail?id=${data.course_id}&courseToken=${data.course_token}`;
        }
      }
      if (openType === "replace") {
        location.replace(openCourseUrl);
      } else {
        window.open(openCourseUrl, "_blank");
      }
    },
    // 保利威直播
    async apiLivePolyvDetail({ id, live_url = "" }, openType) {
      let openUrl = live_url;
      if (!openUrl) {
        const polyvDetail = await livePolyvDetail({ id });
        if (String(polyvDetail.error_no) !== "0") {
          this.$hMessage.error("播放失败");
          return;
        }
        openUrl = polyvDetail.result.live_url;
      }
      if (openType === "replace") {
        location.replace(openUrl);
      } else {
        window.open(openUrl, "_blank");
      }
    },
     //不再提醒
     handleNomore(status){
      if (status) {
        this.nomoreprompt = true
        localStorage.setItem('livenomoreprompt',true)
      } else {
        this.nomoreprompt = false
        localStorage.setItem('livenomoreprompt',false)
      }
    },
    //设置推送开关状态
    changeSwitch(status){
      setWxPushSwitch({
        uapp_id:'public',
        switch_status:status?1:0
      }).then((res) => {
        //成功设置成功，失败跳转引导页
        if (String(res.error_no) === '0') {
          this.switchStatus = status
        } else {
          this.switchStatus = false;
          if(String(res.error_no)==='800107'){
            window.open('/openplat-front/uplusLivePush')
          }else{
            this.$hMessage.error(res.error_info)
          }
        }
      })
    },
    //获取推送开关状态
    getWxPushSwitchStatus(){
      getWxPushSwitch({
        uapp_id: 'public'
      }).then((res) => {
        if (String(res.error_no) === '0') {
          this.switchStatus = res.result.switch_status=='1'?true:false
        } else {
          this.switchStatus = false
        }
      })
    },
  }
};



// WEBPACK FOOTER //
// ./src/gtn/views/uplusLive/index/liveMixin.js